import React, { useState } from "react";

import Topbar from "../navbar/Topbar";
import Sidebar from "../navbar/Sidebar";
import styles from "./userLayout.module.scss";

export default function UserLayout({ children }) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const handleNavToggle = () => {
    setIsNavOpen((previsNavOpen) => !previsNavOpen);
  };
  return (
    <>
      <div className={styles.layoutWrapper}>
        <Topbar
          styles={styles}
          isOpen={isNavOpen}
          clickHandle={handleNavToggle}
        />
        <Sidebar
          styles={styles}
          isOpen={isNavOpen}
          setIsNavOpen={setIsNavOpen}
          clickHandle={handleNavToggle}
        />
        <main className={styles.content}>{children}</main>
      </div>
    </>
  );
}
